import { Stink } from 'components/Stink'
import { ReactNode } from 'react'

export const Lauftext_FR: ReactNode[] = [
  <>
    <p>
      Que ce soit à l'apéritif, au dîner ou lors d'une soirée conviviale où l'on
      dépasse les bornes, l'alcool est profondément ancré dans notre culture.
      Les archéologues ont découvert que des chasseurs-cueilleurs
      semi-sédentaires faisaient déjà fermenter des céréales il y a plus de
      13’000 ans. La première boisson à base de bière d'Europe centrale remonte
      à 6000 ans et a été découverte sur les rives des lacs de Zurich et de
      Constance.
    </p>
  </>,
  <>
    <p>
      Aujourd'hui encore, les Suissesses et les Suisses sont friands de ce
      poison cellulaire enivrant. En termes de quantité, la bière arrive en
      première position. Mais en termes de teneur en alcool, c'est toutefois le
      vin qui arrive en tête. Selon l'Enquête suisse sur la santé, 70% des
      hommes et 50% des femmes boivent de l'alcool chaque semaine. La proportion
      de buveurs et buveuses quotidiens augmente avec l'âge, mais les hommes
      sont toujours au moins deux fois plus nombreux à consommer de l’alcool
      tous les jours. Il est évident qu’un tel comportement peut devenir
      problématique. En Suisse, on estime à environ 250’000 le nombre de
      personnes dépendantes de l'alcool. La consommation d'alcool est à
      l'origine de près d'un décès sur dix.
    </p>
  </>,
  <>
    <p>
      Mais que se passe-t-il exactement dans le corps lorsque nous buvons un ou
      plusieurs verres d'alcool? Comment l'alcool est-il absorbé et dégradé?
      Comment agit-il?
    </p>
  </>,
  <>Absorption</>,
  <>
    <h2>Rapidement dans le sang</h2>
    <p>
      Avant même que nous ayons avalé notre boisson, une partie de l'alcool
      passe directement dans le sang via la muqueuse buccale et la muqueuse de
      l'œsophage. Toutefois, seule une petite quantité emprunte ce chemin.
      Jusqu'à un quart de l'alcool est absorbé par la muqueuse gastrique. La
      majeure partie passe toutefois <b>dans le sang par l'intestin</b>,
      principalement par la partie supérieure de l'intestin grêle.
    </p>
  </>,
  <>
    <h2>Un accélérateur dans le verre</h2>
    <p>
      Plus la concentration d'alcool dans le sang augmente rapidement, plus vite
      on est ivre.
    </p>
  </>,
  <>
    <p>
      En revanche, le taux d'alcool dans le sang augmente plus lentement lorsque
      la <b>vidange gastrique est retardée</b>. En effet, il faut alors plus de
      temps pour que l'alcool parvienne dans l'intestin, où l'absorption est la
      plus efficace. Un estomac plein entraîne donc une augmentation plus lente
      du taux d'alcool dans le sang.
    </p>
  </>,
  <>
    <h2>Répartition dans le corps</h2>
    <p>
      En règle générale, la concentration maximale d'alcool dans le sang est
      atteinte <b>environ une heure après l'ingestion</b>. Ensuite, le taux
      sanguin diminue en raison de la dégradation et de l'élimination, sauf si
      l'on continue à consommer de l'alcool.
    </p>
  </>,
  <>
    <p>
      L'alcool se répartit rapidement et uniformément dans tout le corps par le
      biais du sang. Une partie atteint le cerveau, où il provoque le plus de
      confusion.
    </p>
  </>,
  <>Effets</>,
  <>
    <h2>Confusion dans le cerveau</h2>
    <p>
      L'alcool influence les neurotransmetteurs dans le cerveau et donc par
      conséquence différentes fonctions cérébrales. La capacité visuelle
      diminue, le champ de vision se rétrécit (vision tunnelisée). L'attention,
      la concentration, la capacité de jugement et de réaction diminuent. En
      contrepartie, la propension à prendre des risques augmente.
    </p>
    <p>
      Selon la quantité d'alcool consommée, les performances peuvent être
      légèrement à très fortement réduites. Avec un taux d'alcoolémie de 0,8
      pour mille, le temps de réaction est par exemple{' '}
      <b>prolongé de 30% à 50% par rapport à l'état de sobriété</b>.
    </p>
    <p>
      L'alcool influence également les émotions. Au début, il a un effet
      relaxant ou euphorisant. Avec l'augmentation de la quantité, des
      sentiments négatifs et des comportements inappropriés apparaissent. L'état
      psychique joue un rôle à cet égard. En cas de tristesse ou de colère,
      l'alcool peut améliorer temporairement l'humeur, mais plus tard, il peut
      provoquer une tristesse encore plus profonde et une colère encore plus
      grande.
    </p>
  </>,
  <>
    <h2>Les femmes, les hommes et la graisse corporelle</h2>
    <p>
      En règle générale, les femmes supportent moins bien l'alcool que les
      hommes. Cela s'explique notamment par{' '}
      <b>leur taux de graisse corporelle plus élevé en moyenne</b>. L'alcool se
      dissout mieux dans l'eau que dans la graisse, ce qui explique qu'à poids
      corporel et quantité de consommation égaux, la concentration d'alcool dans
      le sang des femmes est généralement plus élevée que celle des hommes. Les
      femmes disposent par ailleurs de quantités moindres d'alcool
      déshydrogénase.
    </p>
    <p>
      <b>Les jeunes ressentent également l'alcool plus rapidement</b> que les
      adultes. Ils sont généralement plus légers et possèdent moins d'enzymes
      dégradant l'alcool. Surtout, leur corps en pleine croissance et leur
      cerveau encore en développement sont plus vulnérables aux dommages. Les
      adultes plus âgés supportent également moins bien l'alcool, car la{' '}
      <b>proportion d'eau corporelle diminue à nouveau avec l'âge</b>. Le corps
      a par ailleurs besoin de plus de temps pour éliminer l'alcool avec l'âge.
      Les médicaments et les maladies peuvent également influencer les effets de
      l'alcool.
    </p>
    <p>
      À cela s'ajoutent des différences d'ordre génétique.{' '}
      <b>
        Les Asiatiques, par exemple, ont souvent un système enzymatique dit
        atypique
      </b>{' '}
      qui dégrade l'alcool très rapidement ou très lentement. Ces deux
      phénomènes entraînent une forte accumulation de la substance toxique. Le
      corps réagit en dilatant les vaisseaux cutanés, provoquant des maux de
      tête, des nausées, des étourdissements, des palpitations cardiaques et une
      augmentation de la fréquence cardiaque.
    </p>
  </>,
  <>
    <h2>Calculer le taux d'alcoolémie</h2>
    <p>
      Pour calculer le taux d'alcoolémie en pour mille, il faut connaître la
      quantité d'alcool consommée et le poids de la personne concernée.{' '}
      <b>Il faut également tenir compte du sexe</b>: chez les hommes, l'eau
      corporelle représente environ 68% du poids, chez les femmes environ 55%.
      Le calcul de l'alcoolémie se base donc sur une constante de 0,68 pour les
      hommes et de 0,55 pour les femmes. Un verre standard contient 12 grammes
      d'alcool pur et correspond à environ 3 dl de bière, 1 dl de vin ou 2 cl de
      spiritueux.
    </p>
    <p>Formule:</p>
  </>,
  <>
    <h2>Pourquoi a-t-on la gueule de bois?</h2>
    <p>
      Un lendemain de cuite, la gueule de bois est quasi assurée. Les symptômes
      typiques sont des maux de tête, des palpitations cardiaques et des
      nausées. <b>Les causes possibles sont les suivantes:</b>
      <ul>
        <li style={{ marginBottom: '15px' }}>
          <b>Déshydratation:</b> l'alcool fait que le corps élimine trop d'eau
          et se déshydrate.
        </li>
        <li style={{ marginBottom: '15px' }}>
          <b>Substances associées:</b> outre l'éthanol, les boissons alcoolisées
          contiennent souvent des alcools dits supérieurs, des huiles de fusel
          et d'autres substances qui peuvent favoriser la gueule de bois.
        </li>
        <li style={{ marginBottom: '15px' }}>
          <b>Rythme du sommeil:</b> l'alcool raccourcit les phases de rêve et
          prolonge les périodes de sommeil profond. La modification de la
          régulation thermique du corps peut également influencer le sommeil. Le
          lendemain, on se sent donc souvent mal à l'aise et fatigué, même si
          l'on a dormi suffisamment longtemps.
        </li>
      </ul>
      <b>Ce qui aide:</b> beaucoup de liquide et de minéraux peuvent
      rééquilibrer le métabolisme et atténuer les symptômes. Un apport d'oxygène
      et un peu d'exercice physique permettent de relancer la circulation.
    </p>
  </>,
  <>Dégradation</>,
  <>
    <h2>Éliminer et dégrader</h2>
    <p>
      Une fois que la concentration d'alcool dans le sang a atteint son maximum,
      le taux diminue à un rythme de 0,1 à 0,15 pour mille par heure. Environ un
      dixième de l'alcool est éliminé – par les poumons, les reins et la peau.
      Le reste est toutefois dégradé dans le foie.
    </p>
  </>,
  <>
    <h2>Deux étapes de dégradation dans le foie</h2>
    <p>
      L'alcool, plus précisément l'éthanol, est dégradé en deux étapes dans le
      foie à l'aide d'enzymes. La <b>première étape</b> est assurée par{' '}
      <b>l'alcool déshydrogénase</b>. Il en résulte de l'acétaldéhyde, une
      substance toxique qui, en cas de consommation excessive d'alcool, est
      responsable de lésions dans tout le corps. Elle attaque les membranes
      cellulaires et a un effet inhibiteur sur les systèmes enzymatiques.
    </p>
  </>,
  <>
    <p>
      Lors de la <b>deuxième étape</b> de décomposition, l'acétaldéhyde est
      transformé en acétate (acide acétique). Cette transformation se fait à
      l'aide de <b>l'enzyme aldéhyde déshydrogénase</b>. L'acétate subit ensuite
      une nouvelle transformation et est introduit dans la synthèse des acides
      gras et du cholestérol. Si l'on boit beaucoup d'alcool, cela entraîne une
      accumulation d'acides gras dans le foie et finalement une stéatose
      hépatique.
    </p>
  </>,
  <>
    <h2>Autre enzyme en cas d'accoutumance</h2>
    <p>
      En cas de consommation accrue d'alcool, une autre enzyme, appelée{' '}
      <b>oxydase à fonction mixte</b>, est activée. Cela se produit déjà à
      partir d'une concentration d'alcool dans le sang de 0,5 pour mille. Cette
      enzyme est capable de dégrader jusqu'à un quart de l'alcool et est
      présente en plus grande quantité chez les personnes qui boivent
      régulièrement beaucoup. L'alcool est ainsi plus rapidement dégradé en
      acétaldéhyde, raison pour laquelle il faut plus d'alcool pour produire un
      effet enivrant. Cette accoutumance n'a cependant{' '}
      <b>pas d'influence positive</b> sur la santé, car l'acétaldéhyde toxique
      ne se dégrade pas plus rapidement.
    </p>
  </>,
  <>Conséquences</>,
  <>
    <h2>Malade de la tête aux pieds</h2>
    <p>
      Outre les conséquences sociales de l'abus d'alcool, une consommation
      excessive durant plusieurs années peut endommager pratiquement tous les
      organes du corps. Le foie est le plus touché, car c'est là que s'effectue
      la majeure partie de la dégradation de l'alcool. Les cellules sont alors
      endommagées et la graisse s'accumule. Avec le temps, cela entraîne une
      stéatose hépatique et, plus tard, une jaunisse, une cirrhose et un cancer
      du foie. Pour limiter les risques, les hommes ne devraient pas consommer
      plus de deux verres standard par jour, les femmes pas plus d'un. Moins,
      c'est encore mieux. Pour les enfants, les femmes enceintes et celles qui
      allaitent, il serait important de renoncer complètement à l'alcool.
    </p>
  </>,
  <>
    <h2>Accidents et violence</h2>
    <p>
      La consommation excessive d'alcool a également des répercussions sur des
      tiers, provoque des souffrances chez les proches et entraîne des accidents
      et des violences: à la maison, dans la famille, comme dans l'espace
      public. Enfin, la consommation d'alcool a des conséquences dangereuses sur
      la route, où elle est l'une des principales causes de décès et de
      blessures graves. En Suisse, il est interdit de conduire à partir de 0,5
      pour mille. On risque de lourdes amendes et, à partir de 0,8 pour mille,
      un retrait de permis d'au moins trois mois. Les chauffeurs professionnels
      et les nouveaux conducteurs n'ont pas le droit de boire du tout.
    </p>
  </>,
]
